import { useCallback, useRef, useState } from 'react';

/** Keep a pending purchase owned by the modal's parent, even when its form unmounts. */
export const useBudgetModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submitting = useRef(false);

  const onSubmittingChange = useCallback((value: boolean) => {
    submitting.current = value;
    setIsSubmitting(value);
  }, []);

  const open = useCallback(() => {
    if (!submitting.current) setIsOpen(true);
  }, []);

  const dismiss = useCallback(() => {
    if (!submitting.current) setIsOpen(false);
  }, []);

  // A confirmed purchase may close the form before its display data finishes refreshing.
  const complete = useCallback(() => setIsOpen(false), []);

  return { isOpen, isSubmitting, open, dismiss, complete, onSubmittingChange };
};
